import { openDB } from 'idb';

const productData =(data, flag,for_newPromotion) => {
    const saveData = async (data, flag) => {
      if (!("indexedDB" in window)) {
        console.warn("IndexedDB not supported");
        return;
      }

      const dbName = "gt_form";
      const storeName = "product_store";
      const version = 1; //versions start at 1

      const db = await openDB(dbName, version, {
        upgrade(db, oldVersion, newVersion, transaction) {
          const store = db.createObjectStore(storeName);       // eslint-disable-line
        }
      });
      const tx = await db.transaction(storeName, "readwrite");
      const store = await tx.objectStore(storeName);

    
        const isNewPromotion = await store.put({ "key": "is_newPromotion", "value": for_newPromotion },       // eslint-disable-line
         "is_newPromotion")        

 
    }

    saveData(data, flag)
    // if(isSaveDraft===false){
    //   // alert('data')
    // }
    // else{
    
    //   // alert('flag')
    // }
  }

export default class IsDuration {
    
    static isduration(type,state,props,start_date,end_date){
        
     const isNew_createPromotion = (type,state,props,start_date,end_date) => {
        if(type === 'onEmpty') return productData(undefined, true,true)
         const {selectedStartWeek,selectedEndWeek,selectedYear } = state
      let metadata = props.draftData?.duration_detail
      if(type === 'week_start'){
        let filtered = selectedStartWeek&&selectedStartWeek
        if(filtered !== metadata?.WeekStart){
            return productData(undefined,true,true)
        }
      } else if (type === 'week_end'){
        let filtered = selectedEndWeek&&selectedEndWeek
        if(filtered !== metadata?.WeekEnd){
            return productData(undefined,true,true)
        }
      } else  if(type === 'date_start'){
            if(start_date !== metadata?.DateStart){
                return productData(undefined,true,true)
                
            }
        } else if (type === 'date_end'){
            if(end_date !== metadata?.DateEnd){
                return productData(undefined,true,true)
                
            }
        } else if (type === 'year'){
          if(selectedYear !== metadata?.year){
              return productData(undefined,true,true)
              
          }
      }
       
     }
      return (
        isNew_createPromotion(type,state,props,start_date,end_date)
      )
    }
}